import React, { useState } from "react";
import ReviewModal from "./ReviewModal";

interface ReviewButtonProps {
  compraId: number;
  pacoteId: number;
}

const ReviewButton: React.FC<ReviewButtonProps> = ({ compraId, pacoteId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [avaliacao, setAvaliacao] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <button
        className="btn btn-outline-primary btn-sm fw-bold d-flex align-items-center gap-2"
        style={{ borderRadius: "20px", padding: "6px 14px" }}
        onClick={() => setIsModalOpen(true)}
        disabled={loading}
      >
        ⭐ {avaliacao ? "Edit Review" : "Rate"}
      </button>

      {isModalOpen && (
        <ReviewModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          compraId={compraId}
          pacoteId={pacoteId}
          onSubmitted={() => console.log("Review submitted!")}
        />
      )}
    </>
  );
};

export default ReviewButton;